exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index {\n  width: 100vw;\n  line-height: 0;\n  position: relative;\n}\nimg {\n  width: 100vw;\n  line-height: 0;\n}\n.indexBtn {\n  position: absolute;\n  top: 450px;\n  right: 20px;\n  width: 152px;\n  transition: all 200ms;\n}\n.indexBtn:active {\n  opacity: 0.8;\n}\n", ""]);

// exports
